module.exports = "<div ng-attr-id=\"{{vm.identity}}\" text-angular ta-toolbar=\"{{vm.toolbar}}\" ng-model=\"vm.content\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/editor/editor.html
// module id = 452
// module chunks = 0